export const NETWORK_ACTIVITY = 'NETWORK_ACTIVITY'
export const networkActivity = ({ subject, isActive }) => {
  return {
    type: NETWORK_ACTIVITY,
    subject,
    isActive
  }
}